import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import CashoutService from "../../../../services/cashout";
import Observer from "../../utils/observer";
import TicketLogic from "../../utils/ticket-logic";
import {Cell, CustomTable, EmptyRecordsMessage, HCell, HRow, Pagination, Panel, PanelRow, Row} from "../../utils/table-utils";
import MoneyFormatter from "../../utils/money-formatter";
import {OUTCOMES_STATUS} from "../../utils/ticket-statuses";
import OddsFormatter from "../../utils/odds-formatter";

import {CashoutBetsTable} from "../cashout-enhanced";

import * as U from "../../desktop-templates/menu-user";
import User from "../../../../services/user";


export default class CashoutPage extends Component {
    state = {
        response: {},
        livefeed: {},
        tabs: {
            current: '',
            list: {}
        }
    };

    componentWillMount() {
        this.state.tabs.current = 'pending';
        this.state.tabs.list = {
            pending: {
                label: window.Translation(msg`Tutte`),
                description: window.Translation(msg`Tutte le scommesse disponibili per il cashout`)
            },
            livebet: {
                label: window.Translation(msg`Live`),
                description: window.Translation(msg`Scommesse live disponibili al cashout`)
            }
        };

        // CashoutService.loadConfig();

        // Scarica la lista schedine o la paginetta resta vuota
        this.openBetsInterval = setInterval(() => this.fetchOpenBets(), 60e3);
        this.oddsInterval = setInterval(() => this.fetchOdds(), 1.7e3);
        this.performFullUpdate();
        Observer.subscribe('ticket-cashout-done', this.performFullUpdate.bind(this));
    }

    componentWillUnmount() {
        clearInterval(this.oddsInterval);
        clearInterval(this.openBetsInterval);
        Observer.unsubscribe('ticket-cashout-done', this.performFullUpdate.bind(this));
    }

    performFullUpdate() {
        this.fetchOpenBets().then(() => this.fetchOdds());
    }

    fetchOpenBets() {
        return CashoutService.fetchOpenBets().then(betsList => {
            const bets = betsList.filter(ticket => User.data && ticket.player == User.data.id).filter(ticket => this.state.tabs.current === 'pending' || !!ticket.live);
            this.setState({
                response: {
                    totalpages: 1,
                    totalrecords: bets.length,
                    recordperpage: bets.length,
                    page: 1,
                    lowlimit: 0,
                    data: bets
                }
            });
        })
    }

    fetchOdds() {
        const prematchTicketsList = this.state.response.data.filter(t => !t.live);
        const liveTicketsList = this.state.response.data.filter(t => !!t.live);

        if (this.state.tabs.current === 'pending' && !!prematchTicketsList.length) {
            CashoutService
                .fetchCurrentOddsForPrematchTickets(prematchTicketsList)
                .then(() => this.setState({}));
        }

        if (!!liveTicketsList.length) {
            CashoutService
                .fetchCurrentOddsForLiveTickets(liveTicketsList)
                .then(() => this.setState({}));
        }

        this.state.livefeed = CashoutService.fetchLiveEventDataFromTickets();
        this.setState({});
    }

    switchTabs(newtab) {
        this.state.tabs.current = newtab;
        this.performFullUpdate();
    }

    render() {
        return <div>
			<U.SubTabsContainer>
				{Object.entries(this.state.tabs.list).map(
					([key,item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)} >{item.label}</U.Tab>
				)}
			</U.SubTabsContainer>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            <CashoutBetsTable {...this.state.response} livefeed={this.state.livefeed} onIdClick={ticket => TicketLogic.printTicket(ticket)} />
        </div>;
    }
}
